import {Component, OnInit} from '@angular/core';
import {EntityServiceClient, JobStatusInfo} from '@sharedrest/data.restservice';
import {JobTaskResponse} from '@sharedrest/data-custom.restservice';
import {UserService} from '@sharedcommon/services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {FunctionUtils} from '@sharedcommon/util/functions.util';
import {ToastService} from '@sharedcommon/services/toast.service';
import {MatDialogRef} from '@angular/material/dialog';
import { Constants } from '@sharedcommon/util/constants.util';

@Component({
  templateUrl: './calculate-batch-popin.component.html',
})
export class NeqCalculateBatchPopinComponent implements OnInit {

  private jobId: string;
  private jobStatus: JobStatusInfo;
  private jobResult: JobTaskResponse;

  constructor(private readonly userService: UserService,
              private readonly translateService: TranslateService,
              private readonly entityService: EntityServiceClient,
              private readonly toastService: ToastService,
              private readonly dialogRef: MatDialogRef<NeqCalculateBatchPopinComponent>
  ) {
  }

  ngOnInit() {
    this.userService.getJobResult(Constants.JOB_TYPE_CALCULATE_BATCH).subscribe(value => {
      this.jobResult = value;
    });
    this.userService.getJobStatus(Constants.JOB_TYPE_CALCULATE_BATCH).subscribe(value => {
      this.jobStatus = value;
    });
    this.userService.getJobId(Constants.JOB_TYPE_CALCULATE_BATCH).subscribe(value => {
      this.jobId = value;
    });
  }

  showResult(): boolean {
    return FunctionUtils.isDefined(this.jobResult.status);
  }

  showProgress(): boolean {
    switch (this.jobStatus.status) {
      case 'PENDING':
      case 'RUNNING':
        return true;
      default:
        return false;
    }
  }

  getProgressMode(): string {
    switch (this.jobStatus.status) {
      case 'PENDING':
        return 'query';
      case 'RUNNING':
        if (this.jobStatus.progress !== 0) {
          return 'determinate';
        } else {
          return 'query';
        }
      default:
        return '';
    }
  }

  getProgressValue(): number {
    return this.jobStatus.progress;
  }

  getJobStep(): string {
    switch (this.jobStatus.status) {
      case 'PENDING':
        return this.translateService.instant('msg.user.calculate-batch.step.pending');
      case 'RUNNING':
        return this.translateService.instant('msg.user.calculate-batch.step.running');
      case 'FINISHED':
        return this.translateService.instant('msg.user.calculate-batch.step.finished');
      case 'CANCELLED':
        console.error('Cannot manage cancelled job');
        return this.translateService.instant('msg.user.calculate-batch.step.cancelled');
    }
  }

  getJobResult(): string {
    switch (this.jobResult.status) {
      case 'OK':
        return this.translateService.instant('msg.user.calculate-batch.result.ok');
      case 'FAILED':
        return this.translateService.instant('msg.user.calculate-batch.result.failed');
    }
  }

  continue() {
    if (FunctionUtils.isDefined(this.jobResult.status)) {
      this.entityService.rawMaterialscalculateBatchDelete(this.userService.getEntity(), this.jobId).subscribe((_response) => {
        // nothing to do with response
      });
      // result read so remove job
      this.userService.removeJob(Constants.JOB_TYPE_CALCULATE_BATCH);
    }
    this.dialogRef.close(true);
  }

  cancel() {
    this.entityService.rawMaterialscalculateBatchCancelCancel(this.userService.getEntity(), this.jobId).subscribe((_response) => {
      this.userService.removeJob(Constants.JOB_TYPE_CALCULATE_BATCH);
      this.toastService.toast(this.translateService.instant('label.user.calculate-batch.cancel-done'));
    });
    this.dialogRef.close(false);
  }
}
